if (customElements.get("nss-accordion") && !customElements.get("nss-comparison")) {

    const NSSAccordion = customElements.get("nss-accordion");

    class NSSComparison extends NSSAccordion {

        constructor() {
            super();
        }

        connectedCallback() {
            this.media = this.querySelectorAll(".js-nss-comparison-media-row")
            super.connectedCallback();

        }

        handleToggleClick(toggle) {
            const id = toggle.getAttribute("data-id");
            this.media.forEach(el => {
                el.classList.remove("is-show")
            });
            this.querySelector(`.js-nss-comparison-media-row[data-id="${id}"]`)?.classList.add("is-show")
            super.handleToggleClick(toggle);

        }
    }

    customElements.define("nss-comparison", NSSComparison);
}